import type { SxProps } from '@mui/material'
import { ListItem as MUIListItem } from '@mui/material'
interface IListItemProps {
  children: React.ReactNode
  disablePadding?: boolean
  sx?: SxProps
}
export default function ListItem({ children, disablePadding, sx }: IListItemProps) {
  return (
    <MUIListItem disablePadding={disablePadding} sx={sx}>
      {children}
    </MUIListItem>
  )
}
